import { useState, useEffect, useCallback } from "react";


export const useSessionStorage = (key: string, initialValue: string) => {

    const readValue = useCallback(() => {
        console.log('readValue: ', key, initialValue)
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? item : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);

    const [storedValue, setStoredValue] = useState<string>(readValue);

    const updateValue = useCallback(() => {
        console.log('updateValue: ', key, storedValue)
        if (typeof window === 'undefined') {
            return;
        }
        try {
            const newValue = storedValue;
            window.sessionStorage.setItem(key, newValue);
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    },[storedValue])


    useEffect(() => {
        updateValue();
    }, [storedValue]);


    return [storedValue, setStoredValue] as const;

}